import { toast } from "react-toastify";
import { GetAllVendorsApi } from "../../../Api/Operations/Vendors";

/**
 * Vendors Redux Actions
 * Pattern: Action creator + Async thunk with error handling
 */

// Synchronous Action Creator
export const GetAllVendors = (data) => {
  return {
    type: "get_all_vendors",
    payload: data,
    loader: false,
  };
};

// Async Thunk - Fetch all vendors
export function getallVendors(projectId) {
  return async (dispatch) => {
    try {
      const result = await GetAllVendorsApi(projectId);

      if (result.data?.IsSuccess === true) {
        dispatch(GetAllVendors(result.data.Data));
      } else {
        toast.error(result.data?.Message || "Failed to fetch vendors");
      }
    } catch (error) {
      toast.error("Something went wrong while fetching vendors!");
    }
  };
}
